module.exports = __webpack_public_path__ + "img/account-icon.c0efc280.svg";